import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableDefaultVariants = {
  "isRuled": false,
  "stickyHeader": false
}
const tableCompoundVariants = []

const tableSlotNames = [
  [
    "root",
    "Table__root"
  ],
  [
    "body",
    "Table__body"
  ],
  [
    "cell",
    "Table__cell"
  ],
  [
    "cellWrapper",
    "Table__cellWrapper"
  ],
  [
    "cellIcon",
    "Table__cellIcon"
  ],
  [
    "row",
    "Table__row"
  ],
  [
    "foot",
    "Table__foot"
  ],
  [
    "head",
    "Table__head"
  ],
  [
    "headCell",
    "Table__headCell"
  ]
]
const tableSlotFns = /* @__PURE__ */ tableSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableDefaultVariants, getSlotCompoundVariant(tableCompoundVariants, slotName))])

const tableFn = memo((props = {}) => {
  return Object.fromEntries(tableSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableVariantKeys = [
  "isRuled",
  "hasHover",
  "isSelected",
  "isSorted",
  "isFocused",
  "stickyHeader"
]
const getVariantProps = (variants) => ({ ...tableDefaultVariants, ...compact(variants) })

export const table = /* @__PURE__ */ Object.assign(tableFn, {
  __recipe__: false,
  __name__: 'table',
  raw: (props) => props,
  variantKeys: tableVariantKeys,
  variantMap: {
  "isRuled": [
    "true"
  ],
  "hasHover": [
    "true"
  ],
  "isSelected": [
    "true"
  ],
  "isSorted": [
    "true"
  ],
  "isFocused": [
    "true"
  ],
  "stickyHeader": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tableVariantKeys)
  },
  getVariantProps
})